export default "__VITE_ASSET__TASb5u061I6_DFQjxqjx_g__"